import React, { lazy, Suspense } from 'react';

const DynamicIcon = ({ name, ...props }) => {
  if (!name) return null;


  let library = '@ant-design/icons';
  if (name.startsWith('Fi')) library = 'react-icons/fi';
  if (name.startsWith('Hi')) library = 'react-icons/hi';
  if (name.startsWith('Bs')) library = 'react-icons/bs';
  if (name.startsWith('Md')) library = 'react-icons/md';
  if (name.startsWith('Im')) library = 'react-icons/im';
  if (name.startsWith('Tb')) library = 'react-icons/tb';
  if (name.startsWith('Ai')) library = 'react-icons/ai';
  if (name.startsWith('Bi')) library = 'react-icons/bi';
  if (name.startsWith('Gi')) library = 'react-icons/gi';
  if (name.startsWith('Gr')) library = 'react-icons/gr';

  const Icon = lazy(() =>
    import(library).then(module => {
      const IconComp = module[name];
      return IconComp ? { default: IconComp } : { default: () => null };
    }).catch(() => ({ default: () => null }))
  );

  return (
    <Suspense fallback={null}>
      <Icon {...props} />
    </Suspense>
  );
};

export default DynamicIcon;